/* eslint-disable angular/controller-name */

(function iife() {
	"use strict";

	angular.module("dx.webapp.student").controller("StudentRouteController", StudentRouteController);

	function StudentRouteController(
		$routeParams,
		$location,
		$window,
		$scope,
		$q,

		DxStudent,
		student,
		NodeRepository,
		Node,
		group,
		dxLocalize,
		dxSession,
		dxEvent,
		dxDialog,
		RoleTypeEnum,

		DX_EXTENDED_TIME_SETTING,
		examState,
		Raven,
		dxAngularConstantHelper
	) {
		var self = this;

		self.DX_EXTENDED_TIME_SETTING = DX_EXTENDED_TIME_SETTING;

		self.student = new DxStudent();
		self.exams = null;
		self.isFreemium = dxSession.getRole().IsFreemium;
		self.canUpdateStudentCode = dxSession.getRole().roleType === RoleTypeEnum.ACCOUNTMANAGER ||
			dxSession.getRole().roleType === RoleTypeEnum.ADMIN;
		self.groups = null;
		self.studentId = $window.parseInt($routeParams.id, 10);
		self.updateStudentSuccessMessage = "";
		self.updateStudentErrorMessage = "";
		self.loaded = false;

		var initialStudent = {};
		var initialExtendedTime = {};
		var confirmedLeavingPage = false;
		var DX_EVENT_NAME = dxAngularConstantHelper.DX_EVENT_NAME;

		getStudent(self.studentId);
		getExams(self.studentId);
		dxEvent.create(DX_EVENT_NAME.PageviewStudentView);

		function getStudent(id) {
			student.get(id).then(function success(res) {
				self.student = new DxStudent(res);

				if (self.student.redactedPii) {
					self.student.name = dxLocalize.get("RedactedPii.StudentName");
					self.student.code = "";
					self.canUpdateStudentCode = false;
				}

				self.extendedTime = {
					allow: true,
					setting: self.student.extendedTimeSetting,
					percent: 50,
				};

				if (self.extendedTime.setting === DX_EXTENDED_TIME_SETTING.NONE) {
					self.extendedTime.allow = false;
					self.extendedTime.setting = DX_EXTENDED_TIME_SETTING.PERCENT;
				} else if (self.extendedTime.setting === DX_EXTENDED_TIME_SETTING.PERCENT) {
					self.extendedTime.percent = self.student.extendedTimePercent;
				}

				initialStudent = angular.copy(self.student);
				initialExtendedTime = angular.copy(self.extendedTime);

				var promises = [];
				promises.push(getOrganization());
				promises.push(getClasses());

				$scope.$watch("vm.extendedTime.percent", watchExtendedTimePercent);

				return $q.all(promises);
			}).catch(function fail(err) {
				Raven.captureException(err);
				self.student = null;
			}).finally(function done() {
				self.loaded = true;
			});
		}

		function watchExtendedTimePercent(newValue, oldValue) {
			// 9999 was chosen as it's the largest number that fit into the number box.
			if (newValue > 9999) {
				self.extendedTime.percent = oldValue;
			}
		}

		self.updateStudent = function updateStudent() {
			self.student.extendedTimeSetting = self.extendedTime.setting;
			self.student.extendedTimePercent = 0;

			if (!self.extendedTime.allow) {
				self.student.extendedTimeSetting = DX_EXTENDED_TIME_SETTING.NONE;
			}

			if (self.extendedTime.allow && self.extendedTime.setting === DX_EXTENDED_TIME_SETTING.PERCENT) {
				if (typeof (self.extendedTime.percent) !== "number" || self.extendedTime.percent === 0) {
					self.updateStudentErrorMessage = dxLocalize.get("StudentRoute.Error.ExtendedTimePercentNotEntered");
					self.updateStudentSuccessMessage = "";
					return;
				}

				self.student.extendedTimePercent = self.extendedTime.percent;
			}

			student.update(self.student).then(studentUpdateSuccess, studentUpdateFailed);
		};

		function clearSuccessAndErrorMessage() {
			self.updateStudentErrorMessage = "";
			self.updateStudentSuccessMessage = "";
		}

		function studentUpdateSuccess() {
			self.updateStudentSuccessMessage = dxLocalize.get("Feedback.Saved");
			self.updateStudentErrorMessage = "";
			initialStudent = angular.copy(self.student);
			initialExtendedTime = angular.copy(self.extendedTime);
		}

		function studentUpdateFailed() {
			self.updateStudentErrorMessage = dxLocalize.get("Feedback.ErrorSaving");
			self.updateStudentSuccessMessage = "";
		}

		function getOrganization() {
			return NodeRepository.load(self.student.organizationId).then(function success(res) {
				self.organization = new Node(res);
			});
		}

		function getExams(id) {
			student.exams(id).then(function success(res) {
				self.exams = [];
				for (var i = 0; i < res.length; i++) {
					if (!isZeroDate(res[i].start) && !isFutureDate(res[i].start)) {
						res[i].result = getResult(res[i]);
						self.exams.push(res[i]);
					}
				}
			});
		}

		function getClasses() {
			return group.query({studentId: self.student.id}).then(function success(res) {
				self.groups = res.data;
			});
		}

		function isZeroDate(date) {
			return new Date(date).getYear() <= 1;
		}

		function isFutureDate(date) {
			return new Date(date) > new Date();
		}

		function getResult(exam) {
			if (exam.settings.state !== examState.FINAL) {
				return dxLocalize.get("NotHandedIn");
			}
			return exam.settings.grade || dxLocalize.get("NotGraded");
		}

		self.onCodeInputKeypress = function onCodeInputKeypress(event) {
			if (event.keyCode === 13) {
				event.target.blur();
			}
		};

		self.onCodeInputBlur = function onCodeInputBlur() {
			self.isEditingCode = false;
			self.student.code = self.student.code.replace(/\s+/g, ""); // Remove whitespace
		};

		function showConfirmationDialog(redirectURL) {
			dxDialog.confirm({
				actionIsDangerous: true,
				title: dxLocalize.get("LeaveWarning.Title"),
				body: dxLocalize.get("LeaveWarning.Body"),
				acceptText: dxLocalize.get("Ok"),
				acceptCallback: function accept() {
					confirmedLeavingPage = true;
					dxDialog.closeMostRecent();
					$location.url(redirectURL);
				},
				rejectText: dxLocalize.get("Cancel"),
			});
		}

		$scope.$on("$locationChangeStart", function onLocationChangeStart(event) {
			// If the user hasn't already confirmed leaving or saved
			// and the student data was edited and the user hasn't logged out
			if (!confirmedLeavingPage &&
				(!angular.equals(initialStudent, self.student) ||
				!angular.equals(initialExtendedTime, self.extendedTime)) &&
				dxSession.isAuthenticated()) {
				event.preventDefault();
				showConfirmationDialog($location.url());
			}
		});

		$scope.$watch("vm.student", clearSuccessAndErrorMessage, true);
		$scope.$watch("vm.extendedTime", clearSuccessAndErrorMessage, true);
	}
}());
